import { apiInstance } from './api';
import { ApiRoutes } from './consts';

/**
 * Fetches reviews for a Yelp business with optional filters
 * @param filters Optional filter parameters
 * @returns Promise with the reviews data
 */
export const getYelpReviews = async (filters?: {
  minRating?: number;
  maxRating?: number;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  order?: string;
  limit?: number;
  offset?: number;
}) => {
  return apiInstance.get(`${ApiRoutes.Yelp}/business/reviews`, {
    params: filters,
  });
};

/**
 * Calls the endpoint to get the Yelp review URL for writing a review
 * @param accessToken Optional access token for auth
 * @param businessId Optional business id for header
 * @returns Promise with the Yelp review URL or 204 if not available
 */
export const getYelpCreateReviewUrl = async (accessToken?: string, businessId?: string) => {
  return apiInstance.get(
    `${ApiRoutes.Yelp}/business/review-url`,
    accessToken ? {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ...(businessId ? { 'ECHO-Business-ID': businessId } : {}),
      },
    } : undefined
  );
};
